<ng-container *ngIf="isHealthcheck">
  <ng-container *ngIf="secondList['type']">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h3>{{secondList['title'] | translate}}</h3>
      <button mat-dialog-close mat-icon-button>
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
    <div>
      <ul fxLayout="column" fxLayoutGap="4px">
        <li>
          {{healthcheckTextDict[secondList['type']] | translate}}
        </li>
      </ul>
    </div>
  </ng-container>

  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h3>{{title}}</h3>
    <button *ngIf="!secondList['type']" mat-dialog-close mat-icon-button>
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>
  <div>
    <ul fxLayout="column" fxLayoutGap="4px">
      <li *ngFor="let item of list">
        {{item}}
      </li>
    </ul>
  </div>
</ng-container>

<ng-container *ngIf="!isHealthcheck">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h3>{{title}}</h3>
    <button mat-dialog-close mat-icon-button>
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>
  <div>
    <ul fxLayout="column" fxLayoutGap="4px">
      <li *ngFor="let item of list">
        {{item}}
      </li>
    </ul>
  </div>
</ng-container>
